import React, { useState } from "react";
import History from "./History";
import ReadOnlyEmailTemplate from "./ReadOnlyEmailTemplate";
import { useLocation, useNavigate } from "react-router-dom";

const ViewEmailTemplate = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const CurrentTab = parseInt(sessionStorage.getItem("ViewTemplateTab"));
    const [currantTab, setCurrantTab] = useState(CurrentTab || 1);

    const tabs = [
        { value: 1, name: "Information" },
        { value: 2, name: "History" },
    ];

    return (
        <div className="view-template">
            <div className="row mb-3">
                <div className="col">
                    <h4 className="page-title">
                        <button className="btn p-0 fs-5" onClick={() => { window.history.back(); sessionStorage.removeItem("ViewTemplateTab") }}>
                            <i className="bx bx-arrow-back text-pink"></i>
                        </button> Email Template
                        <span>
                            <i className=" ri-arrow-right-s-line"></i> {location?.state?.row?.name || ""}
                        </span>
                    </h4>
                </div>
                
            </div>

            <ul className="nav nav-tabs nav-tabs-bordered">
                {tabs.map((tab) => (
                    <li className="nav-item" role="presentation" key={tab.value}>
                        <button
                            className={`nav-link ${currantTab === tab.value ? "active" : ""}`}
                            type="button"
                            onClick={() => {
                                setCurrantTab(tab.value);
                                sessionStorage.setItem("ViewTemplateTab", tab.value);
                            }}
                        >
                            {tab.name}
                        </button>
                    </li>
                ))}
            </ul>
            <div className="tab-content pt-2">
                <div className={`tab-pane fade ${currantTab === 1 ? 'show active' : ""}`}>
                    <ReadOnlyEmailTemplate />
                </div>
                <div className={`tab-pane fade ${currantTab === 2 ? 'show active' : ""}`}>
                    <History />
                </div>
            </div>
        </div>
    );
};

export default ViewEmailTemplate;
